import React, { FC } from 'react';
import { Box } from '@mui/material';
import { Button } from '@studykik/ui-library';
import { useTranslation } from 'react-i18next';

import { BucketedReward } from '../../../models/paymentSubmissions';
import formatCurrency from '../../../utils/formatCurrency';

import './styles.scss';

export interface ReclaimRewardsTableTableProps {
  reclaimRewards: BucketedReward[];
}

export const ReclaimFundsTable: FC<ReclaimRewardsTableTableProps> = (props) => {
  const { reclaimRewards } = props;

  const { t } = useTranslation();

  const loadExternalRewardLink = (link: string) => {
    if (link) {
      window.open(link, '_blank');
    }
  };

  const renderRow = (row: BucketedReward) => {
    const { id, link, amount, currency } = row;

    return (
      <Box key={`${id}`} className="reclaim-row">
        <div className="reclaim-funds">
          <div className="reclaim-funds-label">
            {t('Pending Reclaim Funds')}
          </div>
          <div className="reclaim-funds-amount">
            {formatCurrency({ amount, currency })} {currency}
          </div>
        </div>
        <div>
          <Button
            type="button"
            onClick={() => loadExternalRewardLink(link)}
            variant="outlined"
            className="claim-funds-button"
          >
            {t('Reclaim Reward')}
          </Button>
        </div>
      </Box>
    );
  };

  return (
    <div className="transactions-table-wrapper">
      <Box className="transactions-table reclaim-funds-table">
        {reclaimRewards.map(renderRow)}
      </Box>
    </div>
  );
};
